import { render, staticRenderFns } from "./SubmitMCTab.vue?vue&type=template&id=3d41518e&scoped=true&lang=pug"
import script from "./SubmitMCTab.vue?vue&type=script&lang=js"
export * from "./SubmitMCTab.vue?vue&type=script&lang=js"
import style0 from "./SubmitMCTab.vue?vue&type=style&index=0&id=3d41518e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3d41518e",
  null
  
)

export default component.exports